export default __webpack_public_path__ + "static/assets/f33a24de106bf6bb7c4b9e2be42d93e8.jpg";